import { gsap } from 'gsap'
import { useCallback, useEffect, useLayoutEffect, useRef } from 'react'

/**
 * The `useHeroAnimation`
 *
 * @param {object} ref - the ref
 * @param {boolean} isActive - whether is active
 */
const useHeroAnimation = (ref, isActive) => {
  const wasActive = useRef(false)
  const tl = useRef()
  const gEl = gsap.utils.selector(ref)

  /**
   * Layout Effect: On mount
   */
  useLayoutEffect(() => {
    gsap.set(gEl('[data-p]'), {
      opacity: 0,
      y: 10
    })

    tl.current = gsap.timeline().to(gEl('[data-p]'), {
      y: 0,
      opacity: 1,
      stagger: {
        each: 0.05,
        from: 'left'
      },
      ease: 'back.out',
      delay: 0.2,
      duration: 0.5
    })

    tl.current.pause()
  }, [])

  /**
   * Show the animation
   */
  const show = useCallback(() => {
    tl.current.play()
  }, [])

  /**
   * Hide the animation
   */
  const hide = useCallback(() => {
    tl.current.reversed(true)
  }, [])

  useEffect(() => {
    if (isActive === wasActive.current) {
      return
    }

    wasActive.current = isActive

    if (isActive) {
      show()

      return
    }

    hide()
  }, [isActive])

  /**
   * Effect: On mount/unmount
   */
  useEffect(() => {
    wasActive.current = false
    tl.current.progress(0)

    return () => {}
  }, [])
}

export default useHeroAnimation
